import { Grid, makeStyles } from "@material-ui/core"
import React from "react"
import { TeamMember } from "./TeamMember"

export default function TeamMembers({ members }) {
  const classes = useStyles()
  return (
    <Grid container>
      {members.map((member, i) => {
        return <Grid id={member.photoName} item xs={12} key={i} className={classes.memberItem}>
          <TeamMember member={member} />
        </Grid>
      })}
    </Grid>
  )
}

const useStyles = makeStyles(theme => ({
  memberItem: {
    padding: theme.spacing(10),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(5),
    },
  },
}))

